<script setup>
import { CAMPAIGN_CONFIG } from '../config.js'

const { copy } = CAMPAIGN_CONFIG
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div class="text-xl text-white" v-html="copy.voted" />
</template>
